import mediumZoom from 'medium-zoom';

class MediumZoom{
    constructor(){
        this.images = document.querySelectorAll(".js-zoom-img");
        this.blogImgs = document.querySelectorAll(".bl-postItem__content img");
        this.event();
    }

    event(){
        mediumZoom(this.images, {
            margin: 24,
            background: '#292d3d',
            scrollOffset: 0,
        });
        mediumZoom(this.blogImgs, {
            margin: 24,
            background: '#292d3d',
            scrollOffset: 0,
        });
    }
}


export default MediumZoom

